// @flow

import React from 'react';
import { Image, Nav, NavItem, NavDropdown, MenuItem } from 'react-bootstrap/lib';
import { IndexLinkContainer } from 'react-router-bootstrap';
import styler from 'react-styling';
import logo from '../../img/symfoni_logo.png';
import { REDIRECT_URL } from '../../../config';

const style = styler `
  Navbar
    position: fixed
    left: 0
    height: 100%
    background-color: #0A152D
    padding: 15px 0 0 0
    width: 60px
    z-index: 1000
  Logo
    max-width: 100px
    visibility: hidden
  Brand
    padding: 5px 0 26px 20px
  MenuIcon
    width: 30px
    font-size: 20px
    text-align: center
    MeetingRoom
      width: 22px
      margin-left: 4px
      margin-top: -2px
    Rolodex
      width: 18px
      margin-left: 6px
  MenuName
    display: none
  User
    background-color: #182B56
    position: absolute
    bottom: 0
    height: 50px
    width: 100%
  UserIcon
    position: absolute
    top: 50%
    left: 50%
    transform: translate(-50%, -50%)
  Dropdown
    width: 100%
    height: 100%
`;

type Props = {
  languagedata: Object,
  me: Object,
};

function _handleLogout() {
  const request = new Request('logout', {
    method: 'POST',
    credentials: 'same-origin',
  });
  fetch(request).then(() => {
    window.location.replace(REDIRECT_URL);
  }).catch(() => {
    // todo: handle/track error
    window.location.replace(REDIRECT_URL);
  });
}

const NavLeftSideSmall = (props: Props) => {
  const lang = props.languagedata;
  return (
    <div style={style.Navbar}>
      <div style={style.Brand}>
        <Image style={style.Logo} src={logo} alt="Logo" />
      </div>
      <Nav bsStyle="pills" stacked activeKey={1}>
        <IndexLinkContainer to="/contacts" activeHref="active" className="menuelement">
          <NavItem eventKey={1}><i className="fa fa-user" style={style.MenuIcon} /> <span style={style.MenuName}>{lang.people}</span></NavItem>
        </IndexLinkContainer>
        <IndexLinkContainer to="/contacts/meetingrooms" activeHref="active" className="menuelement">
          <NavItem eventKey={2}><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 125" x="0px" y="0px" style={style.MenuIcon.MeetingRoom} className="fa"><path d="M2.55,69.76v-18a9.45,9.45,0,1,1,18.9,0V67.52h7.43A9.45,9.45,0,0,1,38.32,77V99H26.63V79.21H12A9.45,9.45,0,0,1,2.55,69.76ZM88,42.35a9.45,9.45,0,0,0-9.45,9.45V67.52H71.13A9.45,9.45,0,0,0,61.68,77V99H73.37V79.21H88a9.45,9.45,0,0,0,9.45-9.45v-18A9.45,9.45,0,0,0,88,42.35ZM12,36.94a9.45,9.45,0,1,0-9.45-9.45A9.45,9.45,0,0,0,12,36.94Zm76,0a9.45,9.45,0,1,0-9.45-9.45A9.45,9.45,0,0,0,88,36.94Zm-38-17a9.45,9.45,0,1,0-9.45-9.45A9.45,9.45,0,0,0,50,19.9ZM45.27,99h9.45V59.81H69.55V50.36H30.45v9.45H45.27ZM65,35.49A10.19,10.19,0,0,0,54.85,25.31H45.15A10.19,10.19,0,0,0,35,35.49v6.86H65Z" /></svg><span style={style.MenuName}>{lang.meeting_rooms}</span></NavItem>
        </IndexLinkContainer>
        <IndexLinkContainer to="/contacts/resources" activeHref="active" className="menuelement">
          <NavItem eventKey={2}><i className="fa fa-car" style={style.MenuIcon} /> <span style={style.MenuName}>{lang.other_resources}</span></NavItem>
        </IndexLinkContainer>
        <IndexLinkContainer to="/favourites" activeHref="active" className="menuelement">
          <NavItem eventKey={3}><i className="fa fa-star" style={style.MenuIcon} /> <span style={style.MenuName}>{lang.favorites}</span></NavItem>
        </IndexLinkContainer>
        <IndexLinkContainer to={`/scheduler?email=${props.me.email}`} activeHref="active" className="menuelement">
          <NavItem eventKey={4}><i className="fa fa-clock-o" style={style.MenuIcon} /> <span style={style.MenuName}>{lang.scheduler}</span></NavItem>
        </IndexLinkContainer>
        <IndexLinkContainer to={`/calendar?email=${props.me.email}`} activeHref="active" className="menuelement">
          <NavItem eventKey={5}><svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 84.4 89.3" style={style.MenuIcon.Rolodex} className="fa"><path d="M72.4,10h-7.6V4c0-2.2-1.8-4-4-4s-4,1.8-4,4v6H27.6V4c0-2.2-1.8-4-4-4s-4,1.8-4,4v6H12C5.4,10,0,15.4,0,22v53.3c0,7.7,6.3,14,14,14h56.4c7.7,0,14-6.3,14-14V22C84.4,15.4,79.1,10,72.4,10z M70.4,81.3H14c-3.3,0-6-2.7-6-6V35.7h68.4v39.6C76.4,78.6,73.8,81.3,70.4,81.3z M76.4,27.6H8V22c0-2.2,1.8-4,4-4h7.6v2.2c0,2.2,1.8,4,4,4s4-1.8,4-4V18h29.2v2.2c0,2.2,1.8,4,4,4s4-1.8,4-4V18h7.6c2.2,0,4,1.8,4,4V27.6L76.4,27.6z" /><path d="M21.5,43.5L21.5,43.5c-3.3,0-5.9,2.6-5.9,5.9c0,3.3,2.6,5.9,5.9,5.9c3.3,0,5.9-2.6,5.9-5.9C27.4,46.1,24.8,43.5,21.5,43.5L21.5,43.5z" /><path d="M42.2,43.5L42.2,43.5c-3.3,0-5.9,2.6-5.9,5.9s2.6,5.9,5.9,5.9c3.3,0,5.9-2.6,5.9-5.9l0,0C48.1,46.1,45.5,43.5,42.2,43.5z" /><path d="M62.9,43.5L62.9,43.5c-3.3,0-5.9,2.6-5.9,5.9s2.6,5.9,5.9,5.9s5.9-2.6,5.9-5.9l0,0C68.8,46.1,66.2,43.5,62.9,43.5L62.9,43.5z" /><path d="M21.5,61.1L21.5,61.1c-3.3,0-5.9,2.6-5.9,5.9c0,3.3,2.6,5.9,5.9,5.9c3.3,0,5.9-2.6,5.9-5.9C27.4,63.7,24.8,61.1,21.5,61.1L21.5,61.1z" /><path d="M42.2,61.1L42.2,61.1c-3.3,0-5.9,2.6-5.9,5.9c0,3.3,2.6,5.9,5.9,5.9c3.3,0,5.9-2.6,5.9-5.9l0,0C48.1,63.7,45.5,61.1,42.2,61.1z" /><path d="M62.9,61.1L62.9,61.1c-3.3,0-5.9,2.6-5.9,5.9c0,3.3,2.6,5.9,5.9,5.9s5.9-2.6,5.9-5.9l0,0C68.8,63.7,66.2,61.1,62.9,61.1L62.9,61.1z" /></svg><span style={style.MenuName}>{lang.calendar}</span></NavItem>
        </IndexLinkContainer>
      </Nav>
      <div style={style.User}>
        <NavDropdown
          className="dropdown-left"
          eventKey={3}
          title={[<i key={1} className="fa fa-user-circle" style={style.UserIcon} />]}
          id="basic-nav-dropdown"
          style={style.Dropdown}
        >
          <MenuItem eventKey={3.2} onSelect={_handleLogout}><i className="fa fa-sign-out" aria-hidden="true" style={{ marginRight: '5px' }} />{lang.log_out}</MenuItem>
        </NavDropdown>
      </div>
    </div>
  );
};

export default NavLeftSideSmall;



// WEBPACK FOOTER //
// ./src/js/Components/NavSideLeftSmall.js